import React from 'react';
import { IMAGES, scrollToBuy } from '../utils/constants';
const BONUSES = [{
  number: '01',
  title: '15 Premium Signature Yoga Classes™',
  image: IMAGES.bonus1,
  lead: 'Fifteen complete, professionally structured classes designed to deliver premium teaching experiences.',
  body: 'Each class includes its objective, duration, target level, complete pose sequence, breathing guidance, transitions, modifications, alignment cues, timing, and instructor notes.',
  tags: '15 Complete Classes · Ready To Teach · Professional Structure'
}, {
  number: '02',
  title: 'Professional Yoga Cueing Masterbook™',
  image: IMAGES.bonus2,
  lead: 'The language and verbal guidance you need to teach with greater clarity, confidence, and professionalism.',
  body: 'Access alignment cues, breathing instructions, transition language, correction phrases, motivational prompts, and relaxation scripts for real classes.',
  tags: 'Alignment · Breathing · Corrections · Transitions · Relaxation'
}, {
  number: '03',
  title: '52 Yoga Class Themes™',
  image: IMAGES.bonus3,
  lead: 'One professionally developed class concept for every week of the year.',
  body: 'Each theme includes an intention, class focus, key poses, breathing practice, meditation idea, teaching notes, and student benefits.',
  tags: '52 Weekly Themes · Fresh Inspiration · Full-Year Variety'
}, {
  number: '04',
  title: 'Student Modification & Adaptation Guide™',
  image: IMAGES.bonus4,
  lead: 'Safely adapt your classes for students with different abilities, limitations, and experience levels.',
  body: 'Includes practical modifications, prop recommendations, movements to avoid, teaching cues, and safety considerations for common student needs.',
  tags: 'Beginners · Seniors · Limited Mobility · Mixed-Level Groups'
}, {
  number: '05',
  title: 'Yoga Workshop & Event Toolkit™',
  image: IMAGES.bonus5,
  lead: 'Plan and deliver professional workshops, specialty classes, and wellness events with greater confidence.',
  body: 'Includes planning templates, timelines, registration documents, participant checklists, event structures, promotional ideas, and follow-up resources.',
  tags: 'Workshops · Specialty Classes · Events · Ready-To-Use Templates'
}];
export function Bonuses() {
  return <section aria-labelledby="bonuses-title" className="w-full bg-ivory px-4 py-10 sm:px-6" data-id="element-19" data-mp="3qgl9bprp6cki">
      <div className="mx-auto max-w-5xl" data-id="element-20" data-mp="2tqc2zlk9g2lo">
        <div className="text-center" data-id="element-21" data-mp="2xtidx6ibihyh">
          <span className="inline-block rounded-full bg-sage/15 px-3 py-1 font-head text-[10px] font-bold uppercase tracking-wider text-sage sm:text-xs" data-id="element-22" data-mp="2xujvzuxr44pp">
            Also included at no extra cost
          </span>
          <h2 id="bonuses-title" className="mt-2 font-head text-2xl font-extrabold uppercase text-charcoal sm:text-3xl" data-id="element-23" data-mp="37lwjybgfiaqg">
            Five Strategic Bonuses
          </h2>
          <p className="mt-1 text-sm text-softgray" data-id="element-24" data-mp="2f164jzt8ygeu">
            100% included today with your Yoga Teaching Vault™ box set.
          </p>
        </div>

        <div className="mt-6 space-y-3" data-id="element-25" data-mp="22lye741qs1ze">
          {BONUSES.map((bonus, index) => <article key={bonus.number} className="grid items-center gap-4 rounded-2xl border border-brand/15 bg-white p-4 md:grid-cols-[220px_1fr]" data-id="element-26" data-mp="1xl2aorlayhui" data-mpi={index}>
              <button type="button" onClick={scrollToBuy} className={`transition hover:opacity-95 ${index % 2 === 1 ? 'md:order-2' : ''}`} aria-label={`Get ${bonus.title}`} data-id="element-27" data-mp="1olnlrwksafc4">
                <img src={bonus.image} alt={`${bonus.title} digital cover`} className="mx-auto w-full max-w-[220px] rounded-xl" loading="lazy" data-id="element-28" data-mp="1et9gituhyql7" />
              </button>
              <div className={index % 2 === 1 ? 'md:order-1' : ''} data-id="element-29" data-mp="10vb4hv3nf68v">
                <span className="font-head text-[10px] font-bold uppercase tracking-widest text-sage" data-id="element-30" data-mp="30xspt672660w">
                  Bonus {bonus.number}
                </span>
                <h3 className="mt-1 font-head text-base font-bold uppercase leading-tight text-charcoal sm:text-xl" data-id="element-31" data-mp="34ymfa405fsvw">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-sm leading-snug text-charcoal" data-id="element-32" data-mp="2w62diuok986u">{bonus.lead}</p>
                <p className="mt-1.5 text-sm leading-snug text-softgray" data-id="element-33" data-mp="2h9jzz2szmc4k">{bonus.body}</p>
                <p className="mt-2 font-head text-[11px] font-semibold uppercase leading-snug tracking-wide text-brand-dark" data-id="element-34" data-mp="2m9ftu97z0n6e">
                  {bonus.tags}
                </p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}